import * as React from 'react';
import { colors } from '../constants';

interface IProps {
    className?: string;
    onClick?(): void;
}

export const BaseArrowBack: React.FC<IProps> = ({ className, onClick }) => (
    <svg
        className={className}
        onClick={onClick}
        viewBox="0 0 24 22"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <g
            id="Page-1"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
        >
            <g
                id="stap-8-2"
                transform="translate(-20.000000, -14.000000)"
                fill={colors.greenDark}
            >
                <g
                    id="iconmonstr-arrow-20-(1)"
                    transform="translate(32.000000, 25.000000) rotate(-180.000000) translate(-32.000000, -25.000000) translate(20.000000, 14.000000)"
                >
                    <polygon
                        id="Path"
                        points="13.025 0 10.178 2.828 16.354 9.004 0 9.004 0 12.996 16.354 12.996 10.178 19.172 13.025 22 24 11"
                    />
                </g>
            </g>
        </g>
    </svg>
);
